<script>
import Layout from '@/components/layout/app-layout'
import appConfig from '@/app.config'
import PageHeader from '@/components/layout/page-header'
import tableMixin from '@/mixins/table'
import api from '@/helpers/api'
/**
 * Dashboard Component
 */
export default {
  name: 'crm.suppliers.list',
  mixins: [tableMixin],
  page: {
    title: 'Purchase - Suppliers',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data () {
    return {
      isLoading: false,
      title: 'Suppliers',
      search: null,
      showSupplierForm: false
    }
  },
  mounted () {
    this.onRefresh()
  },
  watch: {
    search: 'onRefresh',
    currentPage: 'onRefresh',
    perPage: 'onRefresh'
  },
  methods: {
    async onRefresh () {
      this.isLoading = true
      let { items, total_rows } = await api.suppliers.fetchPage({
        page: this.currentPage,
        pageSize: this.perPage === 'All' ? -1 : this.perPage,
        needle: this.search
      })

      this.data = items
      this.totalRows = total_rows
      this.isLoading = false
    }
  },
  computed: {
    breadcrumbs () {
      return [
        {
          text: 'Purchase',
          to: { name: 'purchase' }
        },
        {
          text: 'Suppliers',
          active: true
        }
      ]
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="breadcrumbs"> </PageHeader>
    <div class="mb-4 d-flex justify-content-between align-items-center">
      <g-search-input
        v-model="search"
        placeholder="Find suppliers"
        width="300px"
        class="mr-0 mr-2"
      /><b-btn
        class="btn-label"
        variant="primary"
        v-on:click="showSupplierForm = true"
      >
        <i class="bx bx-plus label-icon"></i>New
      </b-btn>
    </div>
    <div class="row">
      <div
        v-for="supplier in data"
        :key="supplier.id"
        class="col-xl-3 col-lg-3 col-md-4 col-sm-6"
      >
        <app-supplier-grid-card :supplier="supplier" />
      </div>

      <b-col
        v-if="data.length === 0"
        align-self="center"
        class="text-center py-5"
      >
        <b-icon
          icon="cloud-slash"
          variant="dark"
          scale="4"
          class="m-4"
        ></b-icon>

        <h4>No Suppliers Yet!</h4>
      </b-col>

      <div class="d-flex align-items-center justify-end p-0 mt-2">
        <div class="dataTables_length" v-if="totalRows > minPerPage">
          <label class="d-inline-flex align-items-center m-0">
            Show
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="mx-2"
            ></b-form-select
            >Entries
          </label>
        </div>

        <b-pagination
          v-if="perPage !== 'All' && totalRows > perPage"
          class="pagination mb-0"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
        >
          <template v-slot:page="{ page, active }">
            <b v-if="active">{{ page }}</b>
            <i v-else>{{ page }}</i>
          </template>
        </b-pagination>
      </div>
    </div>
    <!-- end row -->

    <app-supplier-form-dialog
      :visible.sync="showSupplierForm"
      v-on:created="onRefresh"
    />
  </Layout>
</template>
